module.exports = __webpack_public_path__ + "img/Ripple-1s-200px.28b3834c.svg";